import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {filter, pluck, Subject, takeUntil} from 'rxjs';
import {roles} from 'src/app/modules/shared/constants/common.constants';
import {profile, selectedUserProfile} from 'src/app/modules/shared/core/shared.selectors';
import {
  FetchActivityTypeRequest,
  FetchColorTypeRequest,
  FetchDataAccordingToDaySelectedRequest,
  FetchMealTypeRequest, FetchScreenTypeRequest,
  FetchTodTypeRequest,
  FetchWeekDaysDetailsRequest
} from '../../core/my-journal.actions';
import { CommonService } from 'src/app/modules/shared/services/common.service';
import { GetWeekDetails } from '../../core/my-journal.selector';
import { sideNavWeeksList } from '../../../behavior-tracker/core/behavior-tracker.selectors';
import moment from 'moment/moment';
import {MyJournalService} from '../../core/my-journal.service';

@Component({
  selector: 'app-my-journal-screen',
  templateUrl: './my-journal-screen.component.html',
  styleUrls: ['./my-journal-screen.component.css']
})
export class MyJournalScreenComponent implements OnInit, OnDestroy {
  role: any;
  groupId: number = null;
  selectedGroupId: number = null;
  selectedUserRole: any;
  selectedDate: any;
  memberId: any;
  showDisclaimerBlock: boolean = false
  weekListToggleData = {
    loading: false,
    weekList: [],
    selectedDate: null,
  };
  private readonly onDestroy: Subject<any> = new Subject<any>();
  showDetailsForAdult = false;

  constructor(private store: Store, private route: ActivatedRoute, private commonService: CommonService, private router: Router, private myJournalService: MyJournalService) {
  }

  ngOnInit(): void {
    this.store.dispatch(FetchMealTypeRequest());
    this.store.dispatch(FetchTodTypeRequest());
    this.store.dispatch(FetchColorTypeRequest())
    this.store.dispatch(FetchScreenTypeRequest());
    this.store.dispatch(FetchActivityTypeRequest());

    this.store
      .select(sideNavWeeksList)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        if (+this.route.snapshot.queryParamMap.get('weekNumber') < 0 || !this.route.snapshot.queryParamMap.get('weekNumber')) {
          setTimeout(()=>{
            if (data.list.length > 0) {
              const selectedWeekNumber = data.list[0].weekNumber;
              const queryParams: Params = { weekNumber: selectedWeekNumber };
              this.router.navigate(
                [],
                {
                  relativeTo: this.route,
                  queryParams,
                }
              );
            }
          },0)
        }
      })
    this.store.select(profile).pipe(takeUntil(this.onDestroy)).subscribe((profileData: any) => {
      if (profileData && profileData.role === roles.adult && !this.route.snapshot.paramMap.get('memberId')) {
        const filteredData = profileData.participants.filter(participant=>!(!participant.groupId || !participant.groupStatusKey || participant.groupStatusKey === 1))
        if(filteredData.length === 0){
          this.showDisclaimerBlock = true
        }
      }
      if (!this.route.snapshot.paramMap.get('memberId')) {
        if (profileData.role === roles.participant && !profileData['groupId']) {
          this.showDisclaimerBlock = true
          return;
        }
        this.showDetailsForAdult = profileData?.role === roles.adult;
      }
    })

    this.store.select(selectedUserProfile).pipe(takeUntil(this.onDestroy),pluck('profile')).subscribe((profileData: any) => {
      if (profileData && profileData?.role === roles.adult && this.route.snapshot.paramMap.get('memberId')) {
        const filteredData = profileData.participants.filter(participant=>!(!participant.groupId || !participant.groupStatusKey || participant.groupStatusKey === 1))
        if(filteredData.length === 0){
          this.showDisclaimerBlock = true
        }
      }
      if (this.route.snapshot.paramMap.get('memberId')) {
        if (profileData.role === roles.participant && !profileData['groupId']) {
          this.showDisclaimerBlock = true
          return;
        }
        this.showDetailsForAdult = profileData?.role === roles.adult;
      }
    })


    this.route.queryParamMap.pipe(takeUntil(this.onDestroy)).subscribe((params: any) => {
      if (params.params.weekNumber && +params.params.weekNumber > 0) {
        this.weekListToggleData.selectedDate = null;
        this.fetchWeeksList();
      }
    });

    this.store.select(profile)
      .pipe(takeUntil(this.onDestroy))
      .subscribe(data => {
        this.role = data?.role
        this.groupId = this.role === roles['adult'] ? -1 : data?.groupId
        if (!this.route?.snapshot?.params['memberId']) {
          this.fetchWeeksList();
        }
      });

    this.store.select(selectedUserProfile)
      .pipe(takeUntil(this.onDestroy),
        filter((data) => !!data.profile))
      .subscribe(data => {
        this.selectedUserRole = data?.profile?.role
        this.selectedGroupId = this.selectedUserRole === roles['adult'] ? -1 : data?.profile?.groupId
        if (this.route?.snapshot?.params['memberId']) {
          this.fetchWeeksList();
        }
      });
    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const urlParams = {
          params: this.route.snapshot.params,
          queryParams: this.route.snapshot.queryParams
        }
        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });

    this.route.paramMap.pipe(takeUntil(this.onDestroy)).subscribe((params: any) => {
      if (params?.params?.memberId) {
        this.memberId = params?.params?.memberId
      }
    })

    this.myJournalService.onWeekDataAdded.pipe(takeUntil(this.onDestroy)).subscribe((added) => {
      if (added) {
        if (!this.selectedDate?.eJournalDataExists) {
          this.fetchWeeksList();
        }
      }
    })

    this.store.select(GetWeekDetails).pipe(takeUntil(this.onDestroy)).subscribe(weekDetails => {
      this.weekListToggleData.loading = weekDetails.loading;
      this.weekListToggleData.weekList = weekDetails?.details?.weekData || [];
      if (!this.weekListToggleData.loading && !this.weekListToggleData.selectedDate && this.weekListToggleData.weekList?.length) {
        const date = this.route.snapshot.queryParamMap.get('date') || moment();
        let weekDay = this.weekListToggleData.weekList.find((weekDay) => moment(weekDay.date).isSame(moment(date), 'date'));
        if (!weekDay) {
          weekDay = this.weekListToggleData.weekList[0];
        }
        this.onSelectedDayChanged(weekDay);
      }
    })
  }

  fetchWeeksList() {
    if (this.route?.snapshot?.queryParams['weekNumber'] && (this.selectedGroupId || this.groupId)) {
      this.store.dispatch(FetchWeekDaysDetailsRequest({
        payload: {
          groupId: this.route.snapshot.params['memberId'] ? this.selectedGroupId : this.groupId,
          weekNumber: this.route?.snapshot?.queryParams['weekNumber'],
          ...(this.route.snapshot.params['memberId'] ? { forUserId: Number(this.route.snapshot.params['memberId']) } : {})
        }
      }));
    }
  }

  onSelectedDayChanged(event) {
    this.weekListToggleData.selectedDate = event?.date;
    this.selectedDate = event;
    this.store.dispatch(FetchDataAccordingToDaySelectedRequest({
      payload: {
        date: this.selectedDate.date,
        ...(this.memberId ? { forUserId: this.memberId } : {})
      }
    }))
  }

  ngOnDestroy(): void {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
